// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CouponCycle;
(function (CouponCycle) {
    CouponCycle[CouponCycle["OneMonth"] = 0] = "OneMonth";
    CouponCycle[CouponCycle["ThreeMonth"] = 1] = "ThreeMonth";
    CouponCycle[CouponCycle["SixMonth"] = 2] = "SixMonth";
    CouponCycle[CouponCycle["Year"] = 3] = "Year";
})(CouponCycle || (CouponCycle = {}));
export var EXT_INSTRUMENT_MESSAGE;
(function (EXT_INSTRUMENT_MESSAGE) {
    EXT_INSTRUMENT_MESSAGE["INSTRUMENT_TYPE"] = "Instrument name";
    EXT_INSTRUMENT_MESSAGE["SYMBOL"] = "Symbol";
    EXT_INSTRUMENT_MESSAGE["TOKEN"] = "Token";
    EXT_INSTRUMENT_MESSAGE["MARKET_TYPE"] = "Market type";
    EXT_INSTRUMENT_MESSAGE["SERIES"] = "Series";
    EXT_INSTRUMENT_MESSAGE["TRADINGUNIT"] = "Trading unit";
    EXT_INSTRUMENT_MESSAGE["PRICEQUOTEUNIT"] = "Price quote unit";
    EXT_INSTRUMENT_MESSAGE["DELIVERYUNIT"] = "Delivery unit";
    EXT_INSTRUMENT_MESSAGE["LOTSIZE"] = "Lot size";
    EXT_INSTRUMENT_MESSAGE["TENDERPERIODSTARTDATE"] = "Tender period start date";
    EXT_INSTRUMENT_MESSAGE["TENDERPERIODENDDATE"] = "Tender period end date";
    EXT_INSTRUMENT_MESSAGE["FLAG_GSM"] = "GSM Flag";
    EXT_INSTRUMENT_MESSAGE["FLAG_ESM"] = "ESM Flag";
    EXT_INSTRUMENT_MESSAGE["FLAG_LONG_ASM"] = "Long term ASM Flag";
    EXT_INSTRUMENT_MESSAGE["FLAG_SHORT_ASM"] = "Short term ASM Flag";
})(EXT_INSTRUMENT_MESSAGE || (EXT_INSTRUMENT_MESSAGE = {}));
export var ExerciseStyle;
(function (ExerciseStyle) {
    ExerciseStyle[ExerciseStyle["EUROPEAN"] = 0] = "EUROPEAN";
    ExerciseStyle[ExerciseStyle["AMERICAN"] = 1] = "AMERICAN";
})(ExerciseStyle || (ExerciseStyle = {}));
export var FixedIncomePricingType;
(function (FixedIncomePricingType) {
    FixedIncomePricingType[FixedIncomePricingType["PercentFromFaceValue"] = 0] = "PercentFromFaceValue";
    FixedIncomePricingType[FixedIncomePricingType["MonetaryValue"] = 1] = "MonetaryValue";
})(FixedIncomePricingType || (FixedIncomePricingType = {}));
